<template>
  <div>
    <template v-for="(block, index) in blocks" :key="index">
      <p v-if="block.title" class="raw-body-2 mb-4">
        <InlineMarkdown :message="block.title" />
      </p>

      <p
        v-if="block.type === 'prose'"
        class="text-[--raw-verydarkgrey] [&:not(:last-child)]:mb-16"
      >
        <InlineMarkdown :message="block.text" />
      </p>

      <ReferenceList
        v-else-if="block.type === 'references'"
        :references="block.references"
        class="[&:not(:last-child)]:mb-16"
      />

      <component
        :is="block.ordered ? 'ol' : 'ul'"
        v-else-if="block.type === 'list'"
        data-method-list
        :data-ordered="block.ordered || undefined"
        class="text-[--raw-verydarkgrey] [&:not(:last-child)]:mb-16"
      >
        <li v-for="(item, itemIndex) in block.items" :key="itemIndex">
          <span><InlineMarkdown :message="item.label" /></span>
          <ScoreCircles v-if="item.score" :score="item.score" />
        </li>
      </component>
    </template>
  </div>
</template>

<script setup lang="ts">
import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import ReferenceList from '~/scopes/campaign/components/UI/ReferenceList.vue'
import ScoreCircles from '~/scopes/campaign/components/highlights/metal/ScoreCircles.vue'

import type { MethodBlock } from './SourcesDoc.types'

// One run of §3's labelled blocks, rendered at both depths: a subsection's own blocks and
// each score type's. Labels are `<p>`, not headings — they label a run rather than open a
// section, and the outline is already at `<h4>` here.
//
// Margin-based spacing (as in `highlights/metal/ContentBlocks.vue`) so a label-less block is
// just a paragraph. Comments stay out of the `v-for`: one there re-emits per iteration.
defineProps<{ blocks: readonly MethodBlock[] }>()
</script>

<style scoped>
[data-method-list] {
  display: grid;
  gap: 0.375rem;
  padding-inline-start: 1.25rem;
  list-style: disc;
  line-height: 1.2;

  &[data-ordered] {
    list-style: decimal;
  }

  li {
    /* The dots sit beside the text, and wrap under it on a narrow card. */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem 0.5rem;
  }
}
</style>
